import React, { useMemo } from "react";

export default function QualityStats({ receipts = [] }) {
  const stats = useMemo(() => {
    const total = receipts.length;
    const withCheck = receipts.filter((r) => r.is_check_issued).length;
    const noCheckNeeded = receipts.filter((r) =>
      ["ПоСчету", "Кредит", "Взаимозачет", "Дилер", "БезОплаты"].includes(r.payment_type)
    ).length;

    let totalScanned = 0;
    let totalExpected = 0;
    receipts.forEach((r) =>
      (r.products || []).forEach((p) => {
        if (p.is_marked) {
          totalExpected += p.actual_quantity || 0;
          totalScanned += p.marks?.length || 0;
        }
      })
    );

    return {
      checkIssued: total ? ((withCheck / total) * 100).toFixed(1) : 0,
      checkNotNeeded: total ? ((noCheckNeeded / total) * 100).toFixed(1) : 0,
      scanned: totalScanned,
      expected: totalExpected,
    };
  }, [receipts]);

  const item = (label, value) => (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        padding: "8px 0",
        borderBottom: "1px solid #f2f2f2",
      }}
    >
      <span>{label}</span>
      <strong>{value}</strong>
    </div>
  );

  return (
    <div
      style={{
        background: "#fff",
        borderRadius: 12,
        padding: 16,
        boxShadow: "0 2px 6px rgba(0,0,0,0.06)",
      }}
    >
      <h3 style={{ marginTop: 0 }}>Качество данных</h3>
      <p style={{ color: "#666" }}>Проверка чеков и маркировок.</p>

      {item("Чеки пробиты", `${stats.checkIssued}%`)}
      {item("Чеки не нужны", `${stats.checkNotNeeded}%`)}
      {item("Сканов по маркировке", `${stats.scanned} / ${stats.expected}`)}
    </div>
  );
}
